<template>
  <f-filter-bar @update:model-value="filterResults">
    <f-filter-bar-category
      title="Includes Required Checks"
      name="includes_required_check"
    >
      <f-filter-bar-option
        title="Includes Required Checks"
        value="1"
        :is-favourite="true"
      />
      <f-filter-bar-option
        title="Excludes Required Checks"
        value="0"
        :is-favourite="true"
      />
    </f-filter-bar-category>
  </f-filter-bar>
</template>

<script>
import { defineComponent } from "vue";
import { useFilterResults } from "../use-filter-results/use-filter-results";
export default defineComponent({
  name: "IncludesRequiredChecksOptions",
  emits: ["update:modelValue"],
  setup(_, { emit }) {
    const { filterResults } = useFilterResults(emit);

    return {
      filterResults,
    };
  }
});
</script>

<style lang="scss" scoped>
  :deep(.divider){
    display: none;
  }

  :deep(.more-filters){
    display: none;
  }
</style>

